<template>
  <!-- comment-item -->
  <section>
    <modal-likes :targetItem="propChildComment" ref="modalLikes"/>
    <div class="flex-box child-comments"  v-if="!deleteComment">
      <span class="info-userimg">
        <span class="isExistUnread" @click="getDetail(propChildComment.userId)" v-bind:class="{isAlive: !getMetaIsDeleted(propChildComment.userId)}">
          <img v-if="getUserInfoById(propChildComment.userId).userIcon" :src="getUserInfoById(propChildComment.userId).userIcon" alt="image" class="img-circle">
          <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
        </span>
      </span>
      <div class="comment">
        <div class="info-userelement">
          <span class="info-username">{{ getUserInfoById(getChildComment.userId).userName || '' }}</span>
          <span class="info-time">
            {{getChildComment.createdAt | preparedTime}}
          </span>
        </div>
          <!-- {{obj}} -->
        <div v-if="getContentText.isDelete">{{getContentText}}</div>
        <div v-else-if="getChildComment.isStamp" class="show-stamp">
          <img :src="getStampImg(getChildComment.isStamp)" :alt="getChildComment.isStamp">
        </div>
        <read-more v-else :targetId="getChildComment.id" :text="getContentText" :isGrayOut="!!propChildComment.isDelete" :addMore="true" :showMore="propShowMore" :contentHeight="propContentHeight" @update-show-more="updateShowMore" @update-content-height="updateContentHeight" :replyTo="getReplyTo(getChildComment)" />
        <image-viewer v-if="getChildComment.uploadedFile" :uploadedFile="getChildComment.uploadedFile" />
        <div class="child-tools">
          <span class="info-menu">
            <a @click.stop="onClickReply('parent', propChildComment.id)" class="info-comment-detail collapse-reply">
              <i class="fa fa-mail-reply fa-rotate-180"></i>
            </a>
            <a class="info-comment" v-if="!propChildComment.isDelete">
              <img v-if="isLiked(propChildComment)" @click.stop="onClickStarLiked(propChildComment, propChildComment.id)" :src="'static/img/assets/nice_on.png'">
              <img v-else @click.stop="onClickStarNotLiked(propChildComment, propChildComment.id)" :src="'static/img/assets/nice_off.png'">
              <span class="like-counter" @click.stop="showModalLikes(propChildComment)" v-if="propChildComment.likes"><strong v-bind:class="{ unread: isUnreadLikeExist(propChildComment.id, propChildComment.userId, propChildComment.likes) }">{{ propChildComment.likes ? Object.keys(propChildComment.likes).length : 0 }}</strong><span>{{ $t('likesCountStr') }}</span></span>
            </a>
          </span>
          <span v-if="checkCommentIsDelete(getChildComment)" class="info-right">
            <comment-drop-down @comment-delete="commentDelete(getChildComment)"/>
          </span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CommentDropDown from '@/components/Comment/CommentDropDown'
import ReadMore from '@/components/ReadMore/ReadMoreComponent'
import ModalLikes from '@/components/Comment/ModalLikes'
import ImageViewer from '@/components/Fb/ImageViewer'
import moment from 'moment'
import { stampsurl } from '@/main'

export default {
  name: 'ChildCommentItem',
  props: {
    propChildComment: {
      type: Object
    }
  },
  components: {
    CommentDropDown,
    ReadMore,
    ModalLikes,
    ImageViewer
  },
  data () {
    return {
      options: {
        showCounter: false,
        widthRatio: 0.5,
        heightRatio: 0.5,
        nav: false,
        enableKeyboard: false,
        close: false
      },
      propShowMore: false,
      propContentHeight: 0,
      deleteComment: false
    }
  },
  computed: {
    ...mapGetters([
      'getUserId'
    ]),
    ...mapGetters('comments/', [
      'getIsReadLikeComment'
    ]),
    ...mapGetters('users/', [
      'getUserInfoById'
    ]),
    ...mapGetters('_meta/', [
      'getMetaIsDeleted'
    ]),
    getChildComment () {
      return this.propChildComment
    },
    getContentText () {
      if (!this.propChildComment.isDelete) {
        return this.propChildComment.contentText
      } else {
        this.deleteComment = true
        return this.$t('deletedComentStr')
      }
    }
  },
  updated: function () {
    console.log(this.getChildComment.userId)
  },
  methods: {
    ...mapActions({
      setReadTime: 'setReadTime'
    }),
    ...mapActions('comments/', {
      removeCommnet: 'REMOVE_COMMENT',
      setLikes: 'SET_LIKES',
      removeLikes: 'REMOVE_LIKES'
    }),
    ...mapActions({
      setReadTime: 'setReadTime'
    }),
    getReplyTo: function (comment) {
      console.log('getReplyTo:', comment)
      let replyTo = ''
      if (comment.parentId) {
        console.log('getReplyTo:parentId', comment.parentId)
        let parentUserName = comment.parentUserName || ''
        if (!parentUserName) {
          let parentUserInfo = this.getUserInfoById(comment.parentId)
          if (parentUserInfo.userName) {
            parentUserName = '@' + parentUserInfo.userName
          }
        }
        console.log('highlightReplyToContentText:parentUserName', parentUserName)
        replyTo = parentUserName
      }
      return replyTo
    },
    getDetail: function (userId) {
      if (!this.getMetaIsDeleted(userId)) {
        this.$router.push({ name: 'User', params: {userId: userId} })
      }
    },
    highlightReplyToContentText: function (comment) {
      console.log('highlightReplyToContentText:', comment)
      if (!(comment && comment.id)) { return '' }
      let contentText = comment.contentText || ''
      if (comment.parentId) {
        console.log('highlightReplyToContentText:parentId', comment.parentId)
        let parentUserName = comment.parentUserName || ''
        if (!parentUserName) {
          let parentUserInfo = this.getUserInfoById(comment.parentId)
          if (parentUserInfo.userName) {
            parentUserName = '@' + parentUserInfo.userName
          }
        }
        console.log('highlightReplyToContentText:parentUserName', parentUserName)
        let re = new RegExp('^' + parentUserName.trim())
        console.log('highlightReplyToContentText:RegExp', re)
        contentText = contentText.replace(re, '<span class="replyto">' + parentUserName + '</span>')
        console.log('highlightReplyToContentText:contentText', contentText)
      }
      return contentText
    },
    onClickStarNotLiked: function (comment, key) {
      this.setLikes({
        key: key,
        userId: this.getUserId
      })
    },
    onClickStarLiked: function (comment, key) {
      this.removeLikes({
        key: key,
        userId: this.getUserId
      })
    },
    onClickStarToggle: function (comment, key) {
      if (this.isLiked(comment)) {
        this.onClickStarLiked(comment, key)
      } else {
        this.onClickStarNotLiked(comment, key)
      }
    },
    isUnreadLikeExist (commentKey, commentOwnerId, likeOwners) {
      for (let likeOwner in likeOwners) {
        if (!this.getIsReadLikeComment(commentOwnerId, commentKey, likeOwner)) {
          return true
        }
      }
      return false
    },
    isLiked: function (comment) {
      if (!comment.likes) {
        return false
      } else {
        return Object.keys(comment.likes).filter(x => x === this.getUserId).length !== 0
      }
    },
    showModalLikes (comment) {
      for (let likeOwner in comment.likes) {
        if (!this.getIsReadLikeComment(comment.userId, comment.id, likeOwner)) {
          this.setReadTime({
            itemType: 'likes',
            targetType: 'comments',
            targetOwner: comment.userId,
            targetId: comment.id,
            likeOwner: likeOwner,
            readTime: new Date().getTime()
          })
        }
      }
      this.$refs.modalLikes.showModal()
    },
    checkCommentIsDelete: function (comment) {
      if (comment.userId === this.getUserId && !comment.isDelete) {
        return true
      } else {
        return false
      }
    },
    onClickReply: function () {
      let parentItem
      console.log('setParentCommentId child:::', this.getChildComment)
      let item = this.getChildComment
      let id = this.getChildComment.id
      parentItem = {
        item: item,
        id: id
      }
      this.$emit('call-set-reply', parentItem)
    },
    commentDelete: function (comment) {
      let deleteInfo = {}
      deleteInfo = {
        parentId: comment.parentId,
        commentId: comment.id,
        targetId: comment.targetId,
        target: comment.target,
        userId: comment.userId,
        targetOwner: comment.targetOwner,
        remtext: this.$t('deletedComentStr')
      }
      if (comment.uploadedFile) {
        console.log('deleteInfo add deleteimage')
        deleteInfo.uploadedFile = comment.uploadedFile
      }
      this.removeCommnet(deleteInfo)
    },
    updateShowMore: function (value) {
      this.propShowMore = value
    },
    updateContentHeight: function (value) {
      this.propContentHeight = value
    },
    getStampImg (key) {
      var url = stampsurl.host + '/stamp/' + key
      return url
    }
  },
  filters: {
    preparedTime: function (date) {
      return moment(date * 1000).format('YYYY/MM/DD HH:mm')
    },
    momentDay: function (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    momentTime: function (date) {
      return moment(date).format('HH:mm:ss')
    }
  }
}
</script>
<style lang="scss" scoped>
.child-comments{
  padding: 10px 0 10px 20px;
  border-top: solid 1px #e7eaec;
}
.new-label{
  font-size: 150%;
  color: 	#FF5F17;
  font-weight: bold;
  font-style: italic;
}
.modal-enter-active, .modal-leave-active {
  transition: all .2s ease ;
}
.modal-enter, .modal-leave-to {
  opacity: 0;
}
.isAlive {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Comment/ChildCommentItem.vue